import { usePageTogglers } from "@Client/@Composables/application-standalone/page-helpers/usePageToggler";
import { defineComponent, onBeforeUnmount, watch } from "@vue/composition-api";
import PageTogglerLayout from "../layout/page-toggler-layout.vue";
import { useScrollTopOnLoad } from "@Shared/@Composables/generic/useScrollTopOnLoad";
import PageStepLayout from "@Client/@Modules/application-standalone/components/layout/page-step-layout.vue";
import IncomeHistorySummary from "@Client/@Modules/application-standalone/components/pages/income-history/income-history-summary.vue";
import IncomeHistoryInformation from "@Client/@Modules/application-standalone/components/pages/income-history/income-history-information.vue";
import AdditionalIncomeInformation from "@Client/@Modules/application-standalone/components/pages/additional-income/additional-income-information.vue";
export default defineComponent({
  name: "IncomeHistoryPage",
  components: {
    PageTogglerLayout,
    IncomeHistorySummary,
    IncomeHistoryInformation,
    AdditionalIncomeInformation,
    PageStepLayout
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    useScrollTopOnLoad();
    const {
      handlePageTogglerNavigation,
      showInformationPage,
      togglerMetadata,
      handleNavigateNext,
      handleNavigateBack,
      navigateToInformationPage
    } = usePageTogglers();
    watch(showInformationPage, newValue => {
      emit("update:showInformationPage", newValue);
      emit("show-errors", 0);
    }, {
      immediate: true
    });
    onBeforeUnmount(() => {
      emit("show-errors", 0);
    });
    return {
      showInformationPage,
      handlePageTogglerNavigation,
      togglerMetadata,
      handleNavigateNext,
      handleNavigateBack,
      navigateToInformationPage
    };
  }
});